export default class Class {
	static get RELATION_TYPE() {
		const RELATION_TYPE = {
			PROJECT: 1,
			MEMBER : 2,
		};

		return RELATION_TYPE;
	}
	
	constructor(params) {
		this.code = params.code;
		this.name = params.name;
		this.relation_code = params.relation_code;
		this.relation_type = params.relation_type;
	}

	asHash() {
		return {
			code: this.code,
			name: this.name,
			relation_code: this.relation_code,
			relation_type: this.relation_type,
		};
	}
}
